// extracted by mini-css-extract-plugin
export default {"buttonContainer":"GameControls_buttonContainer__DtVaT","passButton":"GameControls_passButton__SXBTs","correctButton":"GameControls_correctButton__0hueP"};